var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMobileUpdates = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 19914"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 19913"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 19864"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 19853",
  transform: "translate(-163 -683)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  fill: "none",
  "data-name": "Ellipse 1430",
  transform: "translate(163 683)"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 19857"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 19861"
}, /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  "data-name": "Group 19860"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.244 20.002a11.257 11.257 0 0 1 20.463-6.476",
  "data-name": "Path 27366"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.71 10.547v2.978h-2.978",
  "data-name": "Path 27367"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.757 20a11.257 11.257 0 0 1-20.461 6.476",
  "data-name": "Path 27368"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.291 29.757v-3.278h2.978",
  "data-name": "Path 27369"
}))), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.3,
  "data-name": "Group 19859"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 19858"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.554 15.396a1.315 1.315 0 0 1 1.315-1.315",
  "data-name": "Path 27425"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.554 24.605a1.315 1.315 0 0 0 1.315 1.315",
  "data-name": "Path 27426"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.554 15.396v9.208",
  "data-name": "Line 1709"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.869 14.081h5.262",
  "data-name": "Line 1710"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.869 25.92h5.176",
  "data-name": "Line 1711"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.446 15.396a1.315 1.315 0 0 0-1.315-1.315",
  "data-name": "Path 27427"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.446 15.396v6.577",
  "data-name": "Line 1712"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.446 24.605v-2.631",
  "data-name": "Line 1714"
})), /*#__PURE__*/React.createElement("path", {
  d: "M23.131 25.921a1.315 1.315 0 0 0 1.315-1.315",
  "data-name": "Path 27441"
}))))))));
export { SvgMobileUpdates as ReactComponent };
export default __webpack_public_path__ + "static/media/mobile_updates.fb499bca0ce9634522651fd29c8e78f2.svg";